import React from 'react';
import Basepage, { BasePageState } from '../Basepage';

interface BatterieentsorgungState extends BasePageState {}
interface BatterieentsorgungModel {}

export default class BatterieentsorgungPage extends Basepage<
  BatterieentsorgungState,
  BatterieentsorgungModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="batterieentsorgung">
        Hinweise zur Batterieentsorgung
        <br />
        <br />
        Im Zusammenhang mit dem Vertrieb von Batterien oder mit der Lieferung
        von Geräten, die Batterien enthalten, sind wir verpflichtet, Sie auf
        folgendes hinzuweisen:
        <br />
        Sie sind zur Rückgabe gebrauchter Batterien als Endnutzer gesetzlich
        verpflichtet. Sie können Altbatterien, die wir als Neubatterien im
        Sortiment führen oder geführt haben, unentgeltlich an unserem
        Versandlager (Versandadresse) zurückgeben. Die auf den Batterien
        abgebildeten Symbole haben folgende Bedeutung:
        <br />
        Das Symbol der durchgekreuzten Mülltonne bedeutet, dass die Batterie
        nicht in den Hausmüll gegeben werden darf.
        <br />
        Pb = Batterie enthält mehr als 0,004 Masseprozent Blei
        <br />
        Cd = Batterie enthält mehr als 0,002 Masseprozent Cadmium
        <br />
        Hg = Batterie enthält mehr als 0,0005 Masseprozent Quecksilber.
        <br />
        <br />
        Bitte beachten Sie die vorstehenden Hinweise.
      </div>
    );
  }
  initState(base: BasePageState): BatterieentsorgungState {
    let newState: BatterieentsorgungState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }

  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Batterieentsorgung';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Batterieentsorgung</span>;
  }
  getType(): string {
    return 'BatterieentsorgungPage';
  }
}
